<template>
  <div
    v-if="assignedUsersObject"
    class="multiple-profile-default"
    :class="{ xs: size === 'xs', sm: size === 'sm', md: size === 'md', lg: size === 'lg' }"
  >
    <h-e-profile-default
      v-for="(profile, index) in assignedUsersObject.slice(0, 3)"
      :key="index"
      :first-name="profile.first_name"
      :last-name="profile.last_name"
      :size="size"
      :style="'left : ' + index * 19 + 'px'"
      style="position: absolute; top: 0"
    >
    </h-e-profile-default>
    <i
      v-if="add || assignedUsersObject.length > showNumberFormatted"
      class="mdi mdi-plus-circle-outline mdi-18px cursor-pointer"
      style="position: absolute; top: 2px"
      :style="'left : ' + showNumberFormatted * 19 + 'px'"
    ></i>
  </div>
</template>

<script>
export default {
  name: 'multiple-profile-default',

  props: {
    assignedUsersObject: {
      type: Array,
      required: true,
    },
    size: {
      type: String,
      default: 'md',
    },
    add: {
      type: Boolean,
      default: false,
    },
    showNumber: {
      type: Number,
      default: 3,
    },
  },

  data() {
    return {
      showNumberFormatted: this.showNumber,
    }
  },

  watch: {
    assignedUsersObject() {
      this.setupShowNumber()
    },
  },

  mounted() {
    this.setupShowNumber()
  },

  methods: {
    setupShowNumber() {
      this.showNumberFormatted = this.showNumber
      if (this.showNumberFormatted > this.assignedUsersObject.length) {
        this.showNumberFormatted = this.assignedUsersObject.length
      }
    },
  },
}
</script>

<style scoped></style>
